// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var MM_parser = require("../mm-utils/MM_parser.bs.js");
var FileLoader = require("../utils/FileLoader.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var MM_wrk_editor = require("../worker/MM_wrk_editor.bs.js");
var Expln_React_Row = require("@expln/utils/src/main/react-mui-components/Expln_React_Row.bs.js");
var Expln_React_common = require("@expln/utils/src/main/Expln_React_common.bs.js");
var Select = require("@mui/material/Select").default;
var MenuItem = require("@mui/material/MenuItem").default;
var AutocompleteVirtualized = require("../ui-utils/AutocompleteVirtualized.bs.js");
var IconButton = require("@mui/material/IconButton").default;
var InputLabel = require("@mui/material/InputLabel").default;
var FormControl = require("@mui/material/FormControl").default;
var Delete = require("@mui/icons-material/Delete").default;
var Expln_React_TextFileReader = require("@expln/utils/src/main/react-components/Expln_React_TextFileReader.bs.js");

function MM_cmp_context_selector_single(Props) {
  var modalRef = Props.modalRef;
  var availableWebSrcs = Props.availableWebSrcs;
  var trustedUrls = Props.trustedUrls;
  var onUrlBecomesTrusted = Props.onUrlBecomesTrusted;
  var srcType = Props.srcType;
  var onSrcTypeChange = Props.onSrcTypeChange;
  var fileSrc = Props.fileSrc;
  var onFileChange = Props.onFileChange;
  var parseError = Props.parseError;
  var readInstr = Props.readInstr;
  var onReadInstrChange = Props.onReadInstrChange;
  var label = Props.label;
  var onLabelChange = Props.onLabelChange;
  var allLabels = Props.allLabels;
  var renderDeleteButton = Props.renderDeleteButton;
  var onDelete = Props.onDelete;
  var actAliasSelected = function (alias) {
    var webSrc = availableWebSrcs.find(function (src) {
          return src.alias === alias;
        });
    if (webSrc !== undefined) {
      return FileLoader.loadFileWithProgress(modalRef, !trustedUrls.includes(webSrc.url), onUrlBecomesTrusted, webSrc.url, "Downloading MM file from \"" + alias + "\"", (function (text) {
                    Curry._2(onFileChange, {
                          TAG: /* Web */1,
                          _0: webSrc
                        }, text);
                  }), undefined, "An error occurred while downloading from \"" + alias + "\".", undefined, undefined);
    }
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "Cannot determine a URL for \"" + alias + "\" alias."
          },
          Error: new Error()
        };
  };
  var rndDeleteButton = function (param) {
    if (renderDeleteButton) {
      return React.createElement(IconButton, {
                  onClick: (function (param) {
                      Curry._1(onDelete, undefined);
                    }),
                  children: React.createElement(Delete, {})
                });
    } else {
      return null;
    }
  };
  var rndSourceTypeSelector = function (param) {
    if (Belt_Option.isNone(fileSrc)) {
      return React.createElement(FormControl, {
                  size: "small",
                  children: null
                }, React.createElement(InputLabel, {
                      id: "src-type-select-label",
                      children: "Source type"
                    }), React.createElement(Select, {
                      sx: {
                        width: 130
                      },
                      labelId: "src-type-select-label",
                      label: "Source type",
                      value: MM_wrk_editor.mmFileSourceTypeToStr(srcType),
                      onChange: (function (param) {
                          return Expln_React_common.evt2str((function (str) {
                                        Curry._1(onSrcTypeChange, MM_wrk_editor.mmFileSourceTypeFromStr(str));
                                      }), param);
                        }),
                      children: null
                    }, React.createElement(MenuItem, {
                          value: "Local",
                          children: "Local"
                        }), React.createElement(MenuItem, {
                          value: "Web",
                          children: "Web"
                        })));
    } else {
      return React.createElement("span", undefined, MM_wrk_editor.mmFileSourceTypeToStr(srcType));
    }
  };
  var rndReadInstrTypeSelector = function (param) {
    return React.createElement(FormControl, {
                size: "small",
                children: null
              }, React.createElement(InputLabel, {
                    id: "scope-type-select-label",
                    children: "Scope"
                  }), React.createElement(Select, {
                    labelId: "scope-type-select-label",
                    label: "Scope",
                    value: MM_wrk_editor.readInstrToStr(readInstr),
                    onChange: (function (param) {
                        return Expln_React_common.evt2str((function (str) {
                                      Curry._1(onReadInstrChange, MM_wrk_editor.readInstrFromStr(str));
                                    }), param);
                      }),
                    children: null
                  }, React.createElement(MenuItem, {
                        value: "ReadAll",
                        children: "Read all"
                      }), React.createElement(MenuItem, {
                        value: "StopBefore",
                        children: "Stop before"
                      }), React.createElement(MenuItem, {
                        value: "StopAfter",
                        children: "Stop after"
                      })));
  };
  var rndLabelSelector = function (param) {
    return React.createElement(AutocompleteVirtualized.make, {
                value: label,
                options: allLabels,
                onChange: onLabelChange,
                size: "small"
              });
  };
  var getFileNameFromFileSrc = function (fileSrc) {
    if (fileSrc !== undefined && fileSrc.TAG === /* Local */0) {
      return fileSrc.fileName;
    }
    
  };
  var getAliasFromFileSrc = function (fileSrc) {
    if (fileSrc !== undefined && fileSrc.TAG !== /* Local */0) {
      return fileSrc._0.alias;
    }
    
  };
  var rndSourceSelector = function (param) {
    if (srcType) {
      var alias = getAliasFromFileSrc(fileSrc);
      if (Belt_Option.isNone(alias)) {
        return React.createElement(FormControl, {
                    size: "small",
                    children: null
                  }, React.createElement(InputLabel, {
                        id: "alias-select-label",
                        children: "Alias"
                      }), React.createElement(Select, {
                        sx: {
                          width: 200
                        },
                        labelId: "alias-select-label",
                        label: "Alias",
                        value: Belt_Option.getWithDefault(alias, ""),
                        onChange: (function (param) {
                            return Expln_React_common.evt2str(actAliasSelected, param);
                          }),
                        children: availableWebSrcs.map(function (webSrc, i) {
                              return React.createElement(MenuItem, {
                                          value: webSrc.alias,
                                          children: webSrc.alias,
                                          key: String(i)
                                        });
                            })
                      }));
      } else {
        return React.createElement("span", undefined, Belt_Option.getWithDefault(alias, "<web-src-alias>"));
      }
    } else {
      var fileName = getFileNameFromFileSrc(fileSrc);
      if (Belt_Option.isNone(fileName)) {
        return React.createElement(Expln_React_TextFileReader.make, {
                    onChange: (function (selected) {
                        if (selected !== undefined) {
                          return Curry._2(onFileChange, {
                                      TAG: /* Local */0,
                                      fileName: selected[0]
                                    }, selected[1]);
                        }
                        
                      })
                  });
      } else {
        return React.createElement("span", undefined, Belt_Option.getWithDefault(fileName, "<fileName>"));
      }
    }
  };
  var rndReadInstr = function (param) {
    if (parseError !== undefined) {
      return React.createElement("pre", {
                  style: {
                    color: "red"
                  }
                }, "Error: " + parseError);
    } else if (fileSrc !== undefined) {
      return React.createElement(Expln_React_Row.make, {
                  children: null
                }, rndReadInstrTypeSelector(undefined), readInstr !== 0 ? rndLabelSelector(undefined) : null);
    } else {
      return null;
    }
  };
  return React.createElement(Expln_React_Row.make, {
              alignItems: "center",
              spacing: 1,
              children: null
            }, rndDeleteButton(undefined), rndSourceTypeSelector(undefined), rndSourceSelector(undefined), rndReadInstr(undefined));
}

var make = MM_cmp_context_selector_single;

exports.make = make;
/* react Not a pure module */
